//maybe later we would handle more err cases
export const UNAUTHORIZED = 401;
export const NOT_FOUND = 404;
export const FORBIDDEN = 403;

export const ACCOUNT_ACCESS_REMOVED_TYPE = '/account-access-removed';
export const ACCOUNT_NOT_PROVISIONABLE_TYPE = '/account-not-provisionable';

export const ACCOUNT_REFUSAL_MESSAGES = {
  [ACCOUNT_ACCESS_REMOVED_TYPE]:
    'Your MARKETview access has been removed. Contact your administrator.',
  [ACCOUNT_NOT_PROVISIONABLE_TYPE]:
    "We couldn't set up your MARKETview account. Contact your administrator.",
} as const satisfies Record<string, string>;

export const ACCOUNT_SETUP_FAILED_MESSAGE =
  "We couldn't finish setting up your account. Please try signing in again.";
